import { render, staticRenderFns } from "./WildCardInfoItem.vue?vue&type=template&id=951b8d7a&"
import script from "./WildCardInfoItem.vue?vue&type=script&lang=js&"
export * from "./WildCardInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./WildCardInfoItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports